// Modal.js
import React from "react";
import { useModal } from "./ModalContext";
import Modal from "react-bootstrap/Modal";
const IModal = () => {
  const {
    isModalOpen,
    closeModal,
    modalContent,
    fullscreen,
    size,
    title,
    modalBodyClass,
  } = useModal();

  if (!isModalOpen) return null;

  return (
    <Modal
      show={isModalOpen}
      onHide={closeModal}
      backdrop="static"
      fullscreen={fullscreen}
      size={size}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="text-dark">{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={modalBodyClass}>
        <div className="text-dark p-0">{modalContent}</div>
      </Modal.Body>
    </Modal>
  );
};

export default IModal;
